import React from 'react';
import { LocationPageTemplate } from '../../components/LocationPageTemplate';
export function TempePage() {
  return <LocationPageTemplate city="Tempe" cityShort="Tempe" slug="tempe" data-id="element-1022" />;
}